import Sites from "@/components/sites/sites/Sites";
import Positions from "@/components/sites/positions/Positions";
import SearchEngine from "@/components/sites/searchEngine/SearchEngine";
import Statistic from "@/components/sites/statistic/general/General";
import ChartStatistic from "@/components/sites/statistic/chart/Chart";
import Indexing from "@/components/sites/indexing/Indexing";
import Group from "@/components/sites/group/Group";
import GroupPosition from "@/components/sites/groupPositions/GroupPositions";
import Settings from "@/components/sites/settings/Settings";

export const sites = [
    {path: '/sites', name: 'sites', component: Sites},
    {path: '/sites/positions/:id', name: 'sitePositions', component: Positions},
    {path: '/sites/search-engine', name: 'siteSearchEngine', component: SearchEngine},
    {path: '/sites/statistic', name: 'siteStatistic', component: Statistic},
    {path: '/sites/statistic/chart/:id', name: 'siteChartStatistic', component: ChartStatistic},
    {path: '/sites/indexing/:id', name: 'indexing', component: Indexing},
    {path: '/sites/group', name: 'siteGroup', component: Group},
    {path: '/sites/group-position/:groupId', name: 'groupPosition', component: GroupPosition},
    {path: '/sites/settings/:id', name: 'siteSettings', component: Settings},
]